module.exports = __webpack_public_path__ + "images/xl-yunnan.jpg?5a4e3686eed9a2559cb891a87b4b256d";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-yunnan.jpg
// module id = 210
// module chunks = 1